import React from 'react';
import {
  TRADING_SCORE_ROWS,
  TRADING_SCORE_STYLES,
} from './types';

const Preview: React.FC = () => {
  return (
    <div className="h-full bg-surface p-3 flex items-center justify-center">
      <div className="w-full flex flex-col gap-1.5">
        {TRADING_SCORE_ROWS.map((row) => (
          <div key={row.label || '_neutral'} className="flex items-center gap-1.5">
            <span className="w-8 shrink-0 text-[9px] font-medium text-neutral-500 uppercase tracking-wide">
              {row.label}
            </span>
            <div className="flex-1 grid grid-cols-2 gap-1.5">
              {row.options.map((option) => (
                <div
                  key={option.value}
                  className={[
                    'h-8 rounded-lg border px-1.5 text-[10px] font-semibold text-center flex items-center justify-center',
                    TRADING_SCORE_STYLES[option.value].idle,
                  ].join(' ')}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Preview;
